import { createAsyncThunk } from '@reduxjs/toolkit';

import {
    APIUsersWithNewAccessByAcl,
    APIUsersWithNewAccessByUtm,
    UsersWithNewAccessReportRequest } from './UsersWithNewAccess.api';

export const fetchUsersWithNewAccessByAcl = createAsyncThunk(
    'reports/usersWithNewAccessByAcl',
    async ({ tenantId, request }: { tenantId: string, request: UsersWithNewAccessReportRequest }) => {
        const response = await APIUsersWithNewAccessByAcl({ tenantId, request });
        if (!response.success || response.error) {
            throw new Error(response.error ?? 'Failed to fetch new users access report data (ACL)');
        }
        return response.data;
    }
);

export const fetchUsersWithNewAccessByUtm = createAsyncThunk(
    'reports/usersWithNewAccessByUtm',
    async ({ tenantId, request }: { tenantId: string, request: UsersWithNewAccessReportRequest }) => {
        const response = await APIUsersWithNewAccessByUtm({ tenantId, request });
        if (!response.success || response.error) {
            throw new Error(response.error ?? 'Failed to fetch new users access report data (UTM)');
        }
        return response.data;
    }
);
